export const Footer = () => {
  return (
    <footer>
      <small>© copyright.Built with Firebase</small>
    </footer>
  );
};
